<template>
  <div class="footRoot">
    <ul class="firstUl">
      <span class="bdfont">行业产品</span>
      <li><span class="normalMic" @click="jump('product', 'proPart1Container')">智慧数字沙盘</span></li>
      <li><span class="normalMic" @click="jump('product', 'proPart2Container')">智慧⽣产</span></li>
      <li><span class="normalMic" @click="jump('product', 'proPart3Container')">智慧环保</span></li>
      <!-- <li ><span class="normalMic" @click="jump('product','proPart4Container')">智慧公安</span></li> -->
      <li><span class="normalMic" @click="jump('product', 'proPart5Container')">智慧规划平台</span></li>
    </ul>

    <ul>
      <span class="bdfont">案例</span>
      <!-- <li ><span class="normalMic" @click="jump('samples','sampPart1')">智慧应急指挥管理平台</span></li> -->
      <li><span class="normalMic" @click="jump('samples', 'sampPart1')">智慧环保可视化平台</span></li>
      <li><span class="normalMic" @click="jump('samples', 'sampPart3')">⽣产企业综合管理平台</span></li>
      <li><span class="normalMic" @click="jump('samples', 'sampPart4')">企业级三维空间可视化管理平台</span></li>
      <li><span class="normalMic" @click="jump('samples', 'sampPart5')">城市数字沙盘</span></li>
    </ul>

    <ul>
      <span class="bdfont">关于我们</span>
      <li><span class="normalMic" @click="jump('aboutUs', 'abUsPart1')">公司简介</span></li>
      <li><span class="normalMic" @click="jump('aboutUs', 'abUsPart2')">市场前景</span></li>
      <li><span class="normalMic" @click="jump('aboutUs', 'abUsPart3')">公司优势</span></li>
      <!-- <li ><span class="normalMic" @click="jump('aboutUs','abUsPart4')">合作伙伴</span></li> -->
      <li><span class="normalMic" @click="jump('aboutUs', 'abUsPart5')">联系我们</span></li>
    </ul>

    <div class="bottom">
      <a class="beian" target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2021005466号-1</a>
      <span class="copyright">Copyright © <span>2025</span> 时空视界智能科技（福建）有限公司</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  methods: {
    jump(page, pName) {
      this.$emit('jumpCallBack', { page: page, pName: pName })
    },
  },
}
</script>

<style scoped="scoped">
.normalMic {
  /* font-family: micros; */
  font-size: 14px;
  cursor: pointer;
}
.bdfont {
  /* font-family: microsbd; */
  font-weight: bold;
}

.bottom {
  position: absolute;
  top: 274px;
  left: 50%;
  transform: translateX(-50%);
}

.copyright {
  width: 100%;
  font-size: 12px;
  /* font-family: micros; */
  color: #ffffff;
  line-height: 12px;
  text-align: center;
  display: block;
}

.beian {
	margin-bottom: 10px;
  width: 100%;
  font-size: 12px;
  color: #ffffff;
  line-height: 12px;
  text-align: center;
  display: block;
	text-decoration: none;
}

ul {
  font-size: 18px;
  color: #ffffff;
  line-height: 24px;
  letter-spacing: 1px;
  margin-left: 274px;
  float: left;
  overflow: hidden;
  height: 300px;
}
.firstUl {
  font-size: 18px;
  color: #ffffff;
  line-height: 24px;
  letter-spacing: 1px;
  float: left;
  overflow: hidden;
  margin-left: 485px;
}
li {
  font-size: 14px;
  color: #d9d9d9;
  line-height: 14px;
  margin-top: 20px;
}
.footRoot {
  position: relative;
  width: 1920px;
  height: 300px;
  background: #000000;
  padding-top: 30px;
}
</style>
